
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 189.474 130.088"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M29.232 130.088a31.29 31.29 0 01-10.831-1.87 31.843 31.843 0 01-9.527-5.612 24.1 24.1 0 01-6.656-8.83A28.722 28.722 0 010 102.247a30.247 30.247 0 012.175-11.831 22.513 22.513 0 016.525-8.7 30.962 30.962 0 019.483-5.35 33.586 33.586 0 0111.048-1.784 41.969 41.969 0 0115.835 2.828 32.23 32.23 0 0112.006 8.482V70.753a15.616 15.616 0 00-5.917-12.876c-3.927-3.117-9.078-4.7-15.312-4.7-10.044 0-18.708 3.923-25.752 11.659L4 55.789A44.67 44.67 0 0119.1 45.35a48.033 48.033 0 0118.487-3.48 46.257 46.257 0 0113.094 1.74 31.737 31.737 0 0110.4 5.22 21.6 21.6 0 016.779 8.83 32.262 32.262 0 012.263 12.571V128h-13.05v-9.571a33.012 33.012 0 01-12.093 8.744 40.613 40.613 0 01-15.748 2.915zM34.1 83.977c-6.118 0-11.182 1.727-15.052 5.134a16.788 16.788 0 00-5.828 13.136 16.978 16.978 0 005.828 13.311c3.869 3.406 8.933 5.134 15.052 5.134 10.276 0 18-3.513 22.968-10.44V94.243C51.991 87.431 44.264 83.977 34.1 83.977zM95.528 128H80.563l27.65-37.066 8.235 8.5L95.526 128zm65.6 0H146.16L82.3 43.958h15.14l23.316 32.016 23.49-32.016h14.964l-30.45 40.89L161.123 128zm14.35-100a14 14 0 01-9.9-23.9 14 14 0 0119.8 19.8 13.907 13.907 0 01-9.903 4.1z"}})])
          )
        }
      }
    